import React, { useState } from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ClassTabs = ({ readMore }) => {
  // State to keep track of the active tab
  const [activeTab, setActiveTab] = useState(0);

  const navigate = useNavigate();
  // Array of tab data including images and content
  const tabData = [
    {
      image:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/early.png",
      title: (
        <>
          Early Years <br /> (Nursery–KG)
        </>
      ),
      content: `At Carmel School, Sarangabad, we believe every child is unique and learns best through love, play, and exploration. Our Nursery and Kindergarten program provides a safe, joyful, and caring environment where children build confidence, curiosity, and a lifelong love for learning.`,
      readMore: "/withdrawal",
    },
    {
      image:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/prepatory.png", // Use the imported image
      title: (
        <>
          Preparatory <br />
          (Classes I–V)
        </>
      ),
      content:
        "Our Preparatory stage focuses on developing strong academic foundations while encouraging creativity, communication, teamwork, and independent learning through engaging classroom experiences.",
      readMore: "/withdrawal",
    },
    {
      image:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/middle.png", // Use the imported image
      title: (
        <>
          Middle School
          <br /> (Classes VI–VIII)
        </>
      ),
      content:
        " The Middle School program helps students develop critical thinking, problem-solving abilities, and confidence while providing opportunities to explore different academic and co-curricular activities.",
      readMore: "/withdrawal",
    },
    {
      image:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/secondary.png", // Use the imported image
      title: (
        <>
          Secondary Stage <br />
          (Grades 9–10)
        </>
      ),
      content:
        " The Secondary Stage prepares students for higher academic challenges through focused learning, conceptual understanding, practical activities, and continuous academic guidance.",
      readMore: "/withdrawal",
    },
    {
      image:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/senior-secondary.jpeg", // Use the imported image
      title: (
        <>
          Senior Secondary Stage <br />
          (Grades 11–12)
        </>
      ),
      content:
        "Our Senior Secondary program provides students with focused academic preparation, career guidance, and opportunities to develop the skills required for higher education and their future careers.",
      readMore: "/withdrawal",
    },
  ];

  const handleReadMore = () => {
    const url = tabData[activeTab].readMore;
    navigate(url);
  };

  return (
    <div className="class-tabs">
      <div className="tabs">
        {tabData.map((tab, index) => (
          <div
            key={index}
            className={`tab ${activeTab === index ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            <div className="tabs-img">
              <LazyLoad>
                <img src={tab.image} alt={tab.title} className="tab-image" />
              </LazyLoad>
            </div>
            <div className="tab-title">{tab.title}</div>
          </div>
        ))}
      </div>
      <div className="tabs-content">
        <div className="content">
          <p>{tabData[activeTab].content}</p>
          <button className="button">
            {" "}
           <div className="read-more-wrapper">
  <Link
    to={tabData[activeTab].readMore}
    className="read-more-btn"
  >
    Read More <i className="bi bi-arrow-right"></i>
  </Link>
</div>

          </button>
        </div>
      </div>
    </div>
  );
};

export default ClassTabs;
